import type { ComponentProps } from "react";

import { cn } from "../../lib/utils";
import { useDialogContentContext } from "./DialogContentContext";

export const DialogSection = ({ className, ...props }: ComponentProps<"div">) => {
  const { divided } = useDialogContentContext();
  return (
    <div
      data-slot="dialog-section"
      className={cn(divided && "px-6 py-4 [&:not(:first-child)]:border-t", className)}
      {...props}
    />
  );
};
